import React from 'react';
import NotFoundPage from '../NotFoundPage';

const HomePage = () => (
  <NotFoundPage />
);

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/pages/HomePage/index.js